(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nat-pdp-main"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-nat-pdp]');
    if (!root) return;
    const form = root.querySelector('[data-nat-form]');
    const input = root.querySelector('[data-nat-variant-input]');
    const addButton = root.querySelector('[data-nat-add]');
    const feedback = root.querySelector('[data-nat-feedback]');
    const stock = root.querySelector('[data-nat-stock]');
    const sticky = root.querySelector('[data-nat-sticky]');
    const stickyAdd = root.querySelector('[data-nat-sticky-add]');

    function selectVariant({ variantId, price, option, available }) {
      input.value = variantId;
      root.querySelectorAll('[data-nat-price]').forEach((el) => (el.textContent = price));
      root.querySelectorAll('[data-nat-option-label], [data-nat-option-fact]').forEach((el) => (el.textContent = option));
      const isAvailable = available === 'true';
      addButton.disabled = !isAvailable;
      if (stickyAdd) stickyAdd.disabled = !isAvailable;
      addButton.textContent = isAvailable ? 'Agregar al carrito' : 'Agotado';
      stock.textContent = isAvailable ? '● Disponible' : 'Sin stock por ahora';
      const serviceStock = root.querySelector('[data-nat-service-stock]');
      if (serviceStock) {
        serviceStock.textContent = isAvailable ? 'En stock' : 'Sin stock';
        serviceStock.classList.toggle('is-out', !isAvailable);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      history.replaceState({}, '', url);
    }

    root.querySelectorAll('[data-variant-id]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-variant-id]').forEach((b) => {
          const on = b === button;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', String(on));
        });
        selectVariant({ variantId: button.dataset.variantId, ...button.dataset });
      });
    });

    const select = root.querySelector('[data-nat-variant-select]');
    select?.addEventListener('change', () => {
      const opt = select.selectedOptions[0];
      selectVariant({ variantId: opt.value, ...opt.dataset });
    });

    // Fecha estimada: días hábiles (lunes a viernes) a partir de hoy, según el setting de la sección.
    root.querySelectorAll('[data-nat-eta]').forEach((el) => {
      let days = Number(el.dataset.days);
      const d = new Date();
      while (days > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) days--;
      }
      el.querySelector('[data-nat-eta-date]').textContent = d.toLocaleDateString('es-UY', { day: '2-digit', month: '2-digit' });
    });

    const qty = root.querySelector('[data-nat-qty-input]');
    root.querySelectorAll('[data-nat-qty]').forEach((button) => {
      button.addEventListener('click', () => {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(button.dataset.natQty));
      });
    });



    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      addButton.disabled = true;
      feedback.textContent = 'Agregando…';
      try {
        await window.NatCart.add([{ id: Number(input.value), quantity: Math.max(1, parseInt(qty.value, 10) || 1) }]);
        feedback.textContent = '';
      } catch (error) {
        feedback.textContent = error.message;
      } finally {
        addButton.disabled = false;
      }
    });

    stickyAdd?.addEventListener('click', () => form.requestSubmit());
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => (sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0)).observe(addButton);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nat-product-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nat-grid]').forEach((grid) => {
    const buttons = grid.querySelectorAll('[data-filter]');
    const cards = grid.querySelectorAll('.nat-buycard');
    const empty = grid.querySelector('.nat-grid__empty');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.filter;
        buttons.forEach((b) => {
          const on = b === button;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', String(on));
        });
        let visible = 0;
        cards.forEach((card) => {
          const show = filter === '*' || card.dataset.category === filter;
          card.hidden = !show;
          if (show) visible++;
        });
        if (empty) empty.hidden = visible > 0;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
